module.exports = __webpack_public_path__ + "static/media/aw.f159ec16.svg";